import classNames from "classnames";
import VerifiedIcon from "src/icons/VerifiedIcon";
import Button from "../buttons/Button";
import Modal from "./Modal";

const StoreInventoryStatusModal = ({
  isOpen,
  onClose,
  isLoading = false,
  onSubmit,
}: {
  isOpen: boolean;
  onClose: () => void;
  isLoading: boolean;
  onSubmit: () => void;
}) => {
  return (
    <Modal isOpen={isOpen} closeModal={onClose}>
      <div className="flex flex-col items-center min-w-[300px]">
        <div className="bg-[#E6FCF9] flex items-center justify-between p-3 rounded-full">
          <VerifiedIcon className="" />
        </div>
        <p className="font-semibold text-xl text-black-raisin pt-[26px] pb-2">
          Request Approval Pending
        </p>
        <p className="font-normal text-base text-black-coral">
          Action Required: Complete All Missing Information
        </p>
      </div>
      <div className="flex gap-6 pt-[30px] justify-center">
        <Button
          text={"Cancel"}
          onClick={onClose}
          className="h-[40px] !px-10 flex-[2_1_auto] !border-[#646464] !text-[#646464]"
          ghost
        />
        <Button
          text={isLoading ? "Loading" : "Complete Now"}
          onClick={!isLoading ? onSubmit : () => {}}
          className={classNames("h-[40px] !px-6 flex-[2_1_auto]", {
            "opacity-50 pointer-events-none cursor-wait": isLoading,
          })}
          primary
        />
      </div>
    </Modal>
  );
};

export default StoreInventoryStatusModal;
